export const PAGE_INFO_PROP = 'data._adobe_corpnew.digitalData.page.pageInfo';
export const IMS_CLIENT_PROP = 'data._adobe_corpnew.digitalData.ims.client';
export const CUSTOM_PAGENAME_PROP = `${PAGE_INFO_PROP}.customPageName`;
